import { getPartnerId } from 'core/singleton'
import { layoutSmall } from 'core/util/default'
import React from 'react'
import styled, { css } from 'styled-components'

export interface SkeletonCardProps {
  className?: string
  small?: boolean
}

const SkeletonCard: React.FC<SkeletonCardProps> = (props) => {
  const { className, small } = props
  const smallClassName = getPartnerId() === 'lg-uplus' ? 'small_sf' : 'small'
  return (
    <StyledSkeletonCard
      className={`${small ? smallClassName : undefined} ${className}`}
      smallClassName={smallClassName}
    >
      <div className="skeleton card_wrapper" />
      <div className=" card_info">
        <div className="skeleton info_title" />
      </div>
      <div className="thumbnail_wrapper">
        <div className="skeleton shop_thumbnail" />
        <div className="skeleton shop_name" />
      </div>
    </StyledSkeletonCard>
  )
}

export default SkeletonCard

const StyledSkeletonCard = styled.div<{ smallClassName: 'small' | 'small_sf' }>`
  @keyframes shine {
    to {
      background-position: right -40px top 0;
    }
  }
  .skeleton {
    background-color: ${(props) => props.theme.skeleton};
    background-image: ${(props) => props.theme.skeletonGradation};
    background-size: 40px 100%;
    background-repeat: no-repeat;
    background-position: left -40px top 0;
    animation: shine 1s ease infinite;
  }
  .card_wrapper {
    border-radius: 6px;
    width: 274px;
    height: 368px;
  }
  .card_info {
    padding: 8px 0px 0px 0px;
  }
  .info_title {
    border-radius: 6px;
    height: 20px;
  }
  .thumbnail_wrapper {
    margin-top: 4px;
    display: flex;
  }
  .shop_thumbnail {
    width: 28px;
    height: 28px;
    border-radius: 14px;
  }
  .shop_name {
    /* width: 288px; */
    margin-left: 6px;
    border-radius: 6px;
    flex: 1;
  }

  ${(props) => `
    &.${props.smallClassName} {
      .card_wrapper {
        width: 180px;
        height: 240px;
      }
      .card_info {
        width: 180px;
      }
    }
  `}

  ${(props) =>
    layoutSmall(css`
      .card_wrapper {
        width: 213px;
        height: 283px;
      }
      .card_info {
        width: 213px;
      }
      &.${props.smallClassName} {
        height: 100%;
        .card_wrapper {
          width: 150px;
          height: 200px;
        }
        .card_info {
          width: 150px;
        }
      }
    `)}
`
